import {ImageOptimized} from '@/_application/core/components/ui/image';
import Link from '@/_application/core/components/ui/link';
import {Autoplay, Swiper, SwiperSlide} from '@/_application/core/components/ui/slider';
import {Banner} from '@/__generated__/__types__';
import {getBannerUrlByPath} from '@/_application/helpers/cdn-image';
import {useCallback} from 'react';

const SubBanner = ({banners}: {banners: Banner[]}) => {
    const renderBanner = useCallback((banner: Banner, index: number) => {
        if (!banner?.image_mobile) {
            return null;
        }

        return (
            <SwiperSlide key={banner?.banner_id ?? `${banner?.banner_id}_${index}`}>
                {({isActive}) => (
                    <Link href={`${banner?.url_banner}`}>
                        <div className={`h-[200px] mx-auto transition-all ${isActive ? 'scale-100' : 'scale-[0.92]'}`}>
                            <ImageOptimized
                                className="h-full w-full rounded-md object-cover"
                                src={getBannerUrlByPath(banner?.image_mobile!)}
                                alt={banner?.name ?? 'Banner'}
                                width={493}
                                height={140}
                                loading={'lazy'}
                                // priority={index === 0}
                            />
                        </div>
                    </Link>
                )}
            </SwiperSlide>
        );
    }, []);

    return (
        <div className="w-full bg-white py-4">
            <Swiper
                modules={[Autoplay]}
                centeredSlides
                loop
                updateOnWindowResize
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                }}>
                {banners?.map((banner, index) => renderBanner(banner, index))}
            </Swiper>
        </div>
    );
};

export default SubBanner;
